import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import {
  ClientIpListService
} from '../../../../client/client-ip-journal/client-ip-list/services/client-ip-list/client-ip-list.service'
import { TagEditorTreeNode } from '../tag-editor-tree-node'
import { TagEditorTransformService } from './tag-editor-transform.service'

/**
 * Tag Editor Service
 * Handles tree node data for tag editor
 */
@Injectable({
  providedIn: 'root',
})
export class TagEditorService {
  private clientIpListService = inject(ClientIpListService);
  private transformService = inject(TagEditorTransformService);


  /**
   * Get tree nodes for client (returns TagEditorTreeNode[])
   */
  static getTreeNodesForClient(
    clientId: number,
    clientIpListService: ClientIpListService,
    transformService: TagEditorTransformService,
  ): Observable<TagEditorTreeNode[]> {
    const clientIpNodes$ = clientIpListService.getFilteredTreeNodes(clientId)
    return transformService.transformObservable(clientIpNodes$)
  }

  getTreeForClient(clientId: number): Observable<TagEditorTreeNode[]> {
    return TagEditorService.getTreeNodesForClient(clientId, this.clientIpListService, this.transformService)
  }
}
